var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 18,
    fill: "#FFB547"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5325 31.9334C25.5325 27.2205 29.353 23.4 34.0658 23.4C38.7787 23.4 42.5992 27.2205 42.5992 31.9334C42.5992 33.16 42.3403 34.3263 41.8743 35.3804L42.6008 40.4659L38.2426 39.3763C37.008 40.0707 35.5832 40.4667 34.0658 40.4667M23.4002 37.2667C23.4002 38.0334 23.5619 38.7623 23.8532 39.4211L23.3992 42.5995L26.1228 41.9186C26.8943 42.3525 27.7848 42.6 28.733 42.6C31.6782 42.6 34.0658 40.2122 34.0658 37.2667C34.0658 34.3212 31.6782 31.9334 28.733 31.9334C25.7878 31.9334 23.4002 34.3212 23.4002 37.2667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivechat);
export default __webpack_public_path__ + "static/media/livechat.05806578d151828fcaa53a72429904e0.svg";
export { ForwardRef as ReactComponent };